export const onlyTextRegex = /^[a-zA-Z\s]*$/
export const onlyNumbersRegex = /^\d*$/
